import tippy from 'tippy.js';

export default class AxInfoPanel {

    private static calculateOffset(reference: any) {
        let iconSize = window.getComputedStyle(reference.reference).fontSize;

        let panel = reference.popper.querySelector('.tippy-box');
        let pseudoIcon = reference.popper.querySelector('i');

        let iconFromPanelLeft = pseudoIcon.getBoundingClientRect().left - panel.getBoundingClientRect().left;
        let iconFromPanelTop = pseudoIcon.getBoundingClientRect().top - panel.getBoundingClientRect().top;
        let iconFromPanelRight = pseudoIcon.getBoundingClientRect().right - panel.getBoundingClientRect().right;
        let iconFromPanelBottom = pseudoIcon.getBoundingClientRect().bottom - panel.getBoundingClientRect().bottom;

        switch (reference.popper.querySelector('.tippy-box').attributes['data-placement'].value) {
            case 'right-start':
                return [-iconFromPanelTop, -(iconFromPanelLeft + parseInt(iconSize))];
            case 'left-start':
                return [-iconFromPanelTop, (iconFromPanelRight - parseInt(iconSize))];
            case 'right-end':
                return [-iconFromPanelBottom, -(iconFromPanelLeft + parseInt(iconSize))];
            case 'left-end':
                return [-iconFromPanelBottom, (iconFromPanelRight - parseInt(iconSize))];
            default:
                return [-iconFromPanelTop, -(iconFromPanelLeft + parseInt(iconSize))];
        }
    }

    private static defaultProps: object = {
        theme: "axiomInfoPanel",
        arrow: true,
        maxWidth: 243,
        placement: 'right-start',
        trigger: 'mouseenter focus',
        // trigger: 'click',
        allowHTML: true,
        role: 'tooltip',
        popperOptions: {
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['right-start', 'left-start', 'right-end', 'left-end'],
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        // Have to turn these off otherwise icon positioning breaks
                        mainAxis: false,
                        altAxis: false,
                        tether: false,
                    },
                },
            ],
        },
        interactive: false,
        onMount(reference: any) {
            reference.setProps({
                offset: AxInfoPanel.calculateOffset(reference)
            });
        },
        content: (reference: any) => {
            return `
                <div class="icon-container">
                    <i class="${reference.className}" style="font-size: ${reference.style.fontSize};"></i>
                </div>
                <div class="text-content">
                    ${reference.getAttribute('data-panel-title') ? `
                        <div class="title">
                            ${reference.getAttribute('data-panel-title')}
                        </div>
                    ` : ''}
                    ${reference.getAttribute('data-panel-text') ? `
                        <div class="text">
                            ${reference.getAttribute('data-panel-text')}
                        </div>
                    ` : ''}
                </div>
            `
        }
    }

    // init on specific element
    public static init(item: HTMLElement) {
        if ((item as any)?._tippy) {
            this.destroy(item);
        }
        tippy(item, AxInfoPanel.defaultProps);
        item.classList.add('ax-has-info-panel');
    }

    // Wrapped Tippy methods
    public static destroy(item: HTMLElement) {
        (item as any)._tippy.destroy();
    }

    public static disable(item: HTMLElement) {
        (item as any)._tippy.disable();
    }

    public static enable(item: HTMLElement) {
        (item as any)._tippy.enable();
    }

    public static show(item: HTMLElement) {
        (item as any)._tippy.show();
    }

    public static hide(item: HTMLElement) {
        (item as any)._tippy.hide();
    }
}
